module.exports = __webpack_public_path__ + "8a79415a9a49c5d7c15ced09a545e94a.png";